const dvModal = new DvModal();

let gpGlobal = new (function () {
    let self = this;
    let mapsLoaded = false;
    self.init = init;
    self.modal = null;
    return this;

    function init() {
        initBootstrap();
        if (document.getElementById('tracking-waiting') || document.getElementById('tracking-updating-now')) {
            refreshTracking(document.querySelector('.page-track').dataset.tid, false).then();
        }
        dvModal.on('refresh-user-tracking', function (response) {
            dvModal.hide();
            refreshUserTracking(response['utid'], response['tid'], response['html']).then();
        })
        dvModal.on('refresh-tracking', function (response) {
            dvModal.hide();
            refreshTracking(response['tid'], true).then();
        })
    }

    function initBootstrap() {
        [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function (tooltipTriggerEl) {
            if (bootstrap.Tooltip.getInstance(tooltipTriggerEl)) {
                return bootstrap.Tooltip.getInstance(tooltipTriggerEl);
            } else {
                return new bootstrap.Tooltip(tooltipTriggerEl);
            }
        });
        [].slice.call(document.querySelectorAll('[data-gp-toggle="ajax"]')).map(function (triggerEl) {
            if (!triggerEl.dataset.gpModalAjax) {
                triggerEl.dataset.gpModalAjax = 'rendered';
            }
            triggerEl.addEventListener('click', function (e) {
                e.preventDefault();
                bootstrap.Tooltip.getInstance(triggerEl)?.hide();
                ajaxButtonClick(triggerEl).then();
            });
        });
        [].slice.call(document.querySelectorAll('[data-gp-view="map"]')).map(function (triggerEl) {
            if (!triggerEl.dataset.gpMap) {
                triggerEl.dataset.gpMap = 'rendered';
            }
            if (!mapsLoaded) {
                mapsLoaded = true;
                getScript('https://api-maps.yandex.ru/2.1?lang=ru_RU', loadMap);
            } else {
                loadMap();
            }
            function loadMap() {
                let myMap;
                ymaps.ready(function () {
                    myMap = new ymaps.Map('YMapsID', {
                        center: [ triggerEl.dataset.lat, triggerEl.dataset.long ],
                        zoom: 16,
                        controls: [ 'zoomControl', 'typeSelector' ]
                    });
                    let myGeoObject = new ymaps.GeoObject({
                        geometry: { type: "Point", coordinates: [ triggerEl.dataset.lat, triggerEl.dataset.long ] }
                    });
                    myMap.geoObjects.add(myGeoObject);
                });
            }
        });
    }

    async function ajaxButtonClick(target) {
        let fadeElement = target.closest('.track-container');
        if (fadeElement) {
            if (fadeElement.classList.contains('faded') && !fadeElement.classList.contains('shown')) {
                console.log('faded!');
                return;
            }
            fadeElement.classList.remove('shown');
            fadeElement.classList.add('faded');
        }
        target.setAttribute('disabled', true);
        await dvModal.request(target.dataset.url);
    }

    async function refreshUserTracking(utid, tid, html) {
        if (document.querySelector('body').dataset.currentRoute === 'track-info') {
            return await refreshTracking(tid, true);
        }
        let element = document.querySelector('.track-' + utid);
        if (!element) return;
        element.innerHTML = html;
        element.classList.add('shown');
        initBootstrap();
    }

    async function refreshTracking(tid, forceRefresh) {
        try {
            const fetchResponse = await fetch('/ajax/track/' + tid + '/' + (forceRefresh ? 'info' : 'check'), {
                method: 'get', headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            const data = await fetchResponse.json();
            if (data.data) {
                let page = document.createElement('div');
                page.innerHTML = data.data.trim();
                let titleEl = document.querySelector('.page-track .title');
                let statusEl = document.querySelector('.page-track .status');
                let checkpointsEl = document.querySelector('#fragment-checkpoints');
                let extraEl = document.querySelector('.page-track .extra');
                let historyEl = document.querySelector('.page-track .history');
                titleEl.innerHTML = page.querySelector('.title').innerHTML;
                statusEl.innerHTML = page.querySelector('.status').innerHTML;
                checkpointsEl.innerHTML = page.querySelector('.checkpoints').innerHTML;
                extraEl.innerHTML = page.querySelector('.extra').innerHTML;
                historyEl.innerHTML = page.querySelector('.history').innerHTML;
                initBootstrap();
            }
            if (data.result === 'waiting') {
                setTimeout(() => refreshTracking(tid, false), 3000);
            }
        } catch (err) {
            console.log(err);
        }
    }
})();

document.addEventListener('DOMContentLoaded', function() {
    dvModal.init();
    gpGlobal.init();

    const clipboard = new ClipboardJS('.btn-clipboard', {
        target: trigger => trigger.closest('.bd-code-snippet').querySelector('.highlight'),
        text: trigger => trigger.closest('.bd-code-snippet').querySelector('.highlight')
    });
});

function trackingCaptchaSuccess() {
    document.querySelectorAll('.tracking-form button').forEach(function (el) {
        el.disabled = false;
        console.log(el);
    });
}
